/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewVirustotalDetectedURLItem } from './CRSFSecReviewVirustotalDetectedURLItem';
import {
    CRSFSecReviewVirustotalDetectedURLItemFromJSON,
    CRSFSecReviewVirustotalDetectedURLItemFromJSONTyped,
    CRSFSecReviewVirustotalDetectedURLItemToJSON,
} from './CRSFSecReviewVirustotalDetectedURLItem';

/**
 * 
 * @export
 * @interface CRSFSecReviewVirustotalData
 */
export interface CRSFSecReviewVirustotalData {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewVirustotalData
     */
    asset: string;
    /**
     * 
     * @type {Array<CRSFSecReviewVirustotalDetectedURLItem>}
     * @memberof CRSFSecReviewVirustotalData
     */
    detected_urls?: Array<CRSFSecReviewVirustotalDetectedURLItem>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewVirustotalData
     */
    first_seen?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CRSFSecReviewVirustotalData
     */
    hits?: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewVirustotalData
     */
    last_seen?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewVirustotalData
     */
    total_events: number;
}

/**
 * Check if a given object implements the CRSFSecReviewVirustotalData interface.
 */
export function instanceOfCRSFSecReviewVirustotalData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "total_events" in value;

    return isInstance;
}

export function CRSFSecReviewVirustotalDataFromJSON(json: any): CRSFSecReviewVirustotalData {
    return CRSFSecReviewVirustotalDataFromJSONTyped(json, false);
}

export function CRSFSecReviewVirustotalDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewVirustotalData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'detected_urls': !exists(json, 'detected_urls') ? undefined : ((json['detected_urls'] as Array<any>).map(CRSFSecReviewVirustotalDetectedURLItemFromJSON)),
        'first_seen': !exists(json, 'first_seen') ? undefined : json['first_seen'],
        'hits': !exists(json, 'hits') ? undefined : json['hits'],
        'last_seen': !exists(json, 'last_seen') ? undefined : json['last_seen'],
        'total_events': json['total_events'],
    };
}

export function CRSFSecReviewVirustotalDataToJSON(value?: CRSFSecReviewVirustotalData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'detected_urls': value.detected_urls === undefined ? undefined : ((value.detected_urls as Array<any>).map(CRSFSecReviewVirustotalDetectedURLItemToJSON)),
        'first_seen': value.first_seen,
        'hits': value.hits,
        'last_seen': value.last_seen,
        'total_events': value.total_events,
    };
}

